import ApiService from "./ApiService"

export default {
    get(id) {
        return ApiService().get(`api/organizations/${id}`);
    },

    put(id, payload) {
        return ApiService().put(`api/organizations/${id}`, payload);
    }
}
